module.exports = __webpack_public_path__ + "static/media/pair-logo-white-2.869dd77d.png";